import { routes } from '@/app/routing/router'
import { ProfileView } from './view'

const currentRoute = routes.profile

const ProfilePageRoute = {
  view: ProfileView,
  route: currentRoute,
}

export { currentRoute, ProfilePageRoute }
